import type { FaireProductEntity } from "../../entity_types/product";

export const p_3ew4chqt95: FaireProductEntity = {
  token: "p_3ew4chqt95",
  type: "product",
  name: "Hawaii Beach Ornaments - Hawaii, Maui, Oahu, Kauai",
  brandName: "NMinnick Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/d9016e785cd7c11bddace4ef5a690685199b3913c56f5603773abae84bcef780.png",
  priceDollars: 8.49,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/99cb802e14fb4ef023b6a803e8a7197795a6bc211ca9119b23562e03539c680d.png",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
